"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Quote } from "lucide-react";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function OurPhilosophy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="our-philosophy" className="bg-muted/50 relative w-full py-24 md:py-32 overflow-hidden">
      <div ref={ref} className={cn("container mx-auto px-6 md:px-12 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <div className="mx-auto max-w-4xl flex flex-col md:flex-row items-center md:items-start gap-10 md:gap-16">
          {}
          <div className="flex-1 text-center md:text-left order-2 md:order-1">
            <div className="flex items-center justify-center md:justify-start gap-3 mb-6">
              <span className="h-px w-8 bg-primary/40"></span>
              <span className="text-xs font-medium tracking-widest uppercase text-muted-foreground">
                Our Philosophy
              </span>
            </div>

            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl leading-tight text-foreground mb-8 italic">
              "Organization isn't about perfection. It's about creating a home
              that serves your life, not the other way around. A calm space
              cultivates a calm mind."
            </h2>

            <div className="flex flex-col md:flex-row items-center md:items-start gap-4">
              <div className="text-center md:text-left">
                <p className="font-medium text-foreground text-lg">
                  Emily Johnson
                </p>
                <p className="text-muted-foreground text-sm">
                  Founder & Home Organization Expert
                </p>
              </div>
            </div>
          </div>

          {}
          <div className="order-1 md:order-2 shrink-0 relative">
            <div className="relative">
              <div className="absolute -inset-4 bg-background/50 rounded-full blur-xl opacity-70"></div>
              <SafeHydrate><Avatar className="h-32 w-32 md:h-40 md:w-40 border-4 border-background shadow-xl">
                <AvatarImage src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573125/img/founder_emily_candid.png" alt="Emily Johnson" className="object-cover" />
                <AvatarFallback>EJ</AvatarFallback>
              </Avatar></SafeHydrate>
              <div className="absolute -bottom-2 -right-2 bg-background p-2 rounded-full shadow-sm text-primary">
                <Quote className="w-5 h-5 fill-current opacity-80" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}